import { render, staticRenderFns } from "./PickupRequests.vue?vue&type=template&id=a73313d4&"
import script from "./PickupRequests.vue?vue&type=script&lang=js&"
export * from "./PickupRequests.vue?vue&type=script&lang=js&"
import style0 from "./PickupRequests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports